import { render, staticRenderFns } from "./CategoryTag.vue?vue&type=template&id=89dd1e8a&scoped=true&"
import script from "./CategoryTag.vue?vue&type=script&lang=js&"
export * from "./CategoryTag.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTag.vue?vue&type=style&index=0&id=89dd1e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd1e8a",
  null
  
)

export default component.exports